<template>
  <div>
    <!-- TAGGED -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              Tagged Style BG & Dropdown Menu & Hover Effect & Selected List Item
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <multiselect v-bind="Config" />
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>

export default {
  name: 'Tagged',
  data() {
    return {
      Config: {
        'close-on-select': false,
        placeholder: 'Seçiniz',
        multiple: true,
        labelText: 'Options',
        labelHelpText: '',
        name: 'selectList',
        label: 'displayName',
        'track-by': 'value',
        options: [
          { displayName: 'Option1', value: 1 },
          { displayName: 'Option2', value: 2 },
          { displayName: 'Option3', value: 3 },
        ],
        loading: false,
        searchable: true,
        allowEmpty: true,
      },
    };
  },
  computed: {},
};
</script>
